module.exports = new __parcel__URL__("empty.e5bcf0dc.png").toString();